<template>
  <v-card>
    <v-img
      src="https://cdn.vuetifyjs.com/images/cards/desert.jpg"
      aspect-ratio="2.75"
    ></v-img>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">{{currentCategory.name}}</h3>
        <div class="mt-3">{{currentCategory.description}}</div>
      </div>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "IntroduceCategory",
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState("client", {
      currentCategory: state => state.game.currentCategory
    })
  }
};
</script>